goog.provide('el8.app.settings.letterRouting');
goog.provide('el8.app.settings.letterRoutingReact');

goog.require('el8.appservice.notifier');
goog.require('el8.data.letterCategories');
goog.require('el8.data.letterRoutes');
goog.require('el8.template.app.settings.letterRouting');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.Form');

el8.app.settings.letterRoutingReact = el8.app.settings.reactTab({
    containerId: 'patient-passport-messages',
    renderFnName: 'renderPatientPassportMessages',
    props: {
      practiceId: el8Globals.PRACTICE_ID
    }
});

el8.app.settings.letterRouting = (function() {
    var that = {
        _container: null,
        _bulkForm: null
    };

    that._getletterCategoriesJSNames = function () {
        return _(el8.data.letterCategories.all()).map(function (lrc) {
            return lrc.getKey().replace(/_/g, '-');
        });
    },
    that._getPracticeUsersFullNames = function () {
        return _(el8.data.practiceUsers.all()).map(
            function(u){ return u.getFullName(); }
        );
    },
    that._getRoutesForDisplay = function () {
        var routesByProviderForDisplay = [];

        // for each provider in the practice
        _(el8.data.letterRoutes.all()).each(function(providerRoutesObj){

            // iterate over all the rules (one per category)
            _(providerRoutesObj.getRules()).each(function (rule) {

                // augment with user and staff group names and pretty category
                var userAndGroupNames = _(rule.getUserIds()).map(function(uid) {
                    return el8.data.practiceUsers.getById(uid).getFullName();
                });

                userAndGroupNames = userAndGroupNames.concat(
                    _.compact(_(rule.getStaffgroupIds()).map(function(sgid) {
                        var group = el8.data.staffGroups.getById(sgid);
                        return group ? group.getName() : null;
                    }))
                );

                var cat = _(el8.data.letterCategories.all()).find(function (c) {
                    return c.getKey() === rule.getCategory();
                });

                return _(rule).extend({
                    userAndGroupNames: userAndGroupNames,
                    prettyCategory: cat.getText()
                });
            });

            var physicianUser = el8.data.practiceUsers.getById(providerRoutesObj.getPhysicianUserId());

            routesByProviderForDisplay.push({
                id: physicianUser.getId(),
                fullName: physicianUser.getFullName(),
                rules: providerRoutesObj.getRules()
            });
         });

        return routesByProviderForDisplay;
    },
    that._bindTriggers = function () {
        that._container.on('change', ':input[name="passportMessagesEnabled"]',  function() {
            var msgElt = $('.confirm-msg', $('#passport-messages-toggle-section'));

            el8.data.practiceSettings.updatePassportMessagesEnabled(
                $(this).val() === 'true' ? true : false,
                function() { el8.app.settings.util.handleSavedMsg(msgElt); });

            if ($(this).val() === 'true') { $('.routing-ui-container').show(); }
            else { $('.routing-ui-container').hide(); }
        });

        that._container.on('click', '#update-for-all-trigger',  function() {
            $('.bulk-edit-form-div', that._container).show();
        });

        // bind to the "change routing" link on the provider's <div>
        $('.provider-customization-section', that._container)
            .on('click', '.edit-provider-trigger',  function() {
                $('#div-provider-'+$(this).data('id')).hide();
                var selectedPhysicianUserId = $(this).data('id');
                var selectedPhysicianRoute = _.find(el8.data.letterRoutes.all(), function(physRouteObj){
                    if (physRouteObj.getPhysicianUserId() === selectedPhysicianUserId) {
                        return physRouteObj;
                    }
                });
                if (selectedPhysicianRoute) {
                    var form = that._createProviderForm(selectedPhysicianRoute);
                    that._createProviderFormSaveButton(form, selectedPhysicianRoute);
                    that._createProviderFormCancelButton(form, selectedPhysicianRoute);
                    form.render();
                    that._loadAndUpdateFormLEs(form, selectedPhysicianRoute); // must be after render
                    $('#edit-form-provider-'+$(this).data('id')).show();
                }
        });

        // set enabled/disabled toggle
        var passportMessagesEnabled = el8.data.practiceSettings.isPassportMessagesEnabled();
        $(':input[name="passportMessagesEnabled"]', that._container)
            .filter('[value="'+passportMessagesEnabled+'"]')
            .prop('checked', true);

        if (passportMessagesEnabled) { $('.routing-ui-container', that._container).show(); }
    },
    that._createBulkForm = function () {
        var fields = [];
        var contentElt = $('.bulk-edit-form', that._container);

        _(that._getletterCategoriesJSNames()).each(function (name) {
            var n = name + '-recip';

            var mrOpts = $.extend(el8.appshared.mindreaderOpts.practiceUsersAndStaffGroups(), {
                formatSelected: function(item) { return null; },
                selectFn: function(event, item) {
                    var le = that._bulkForm.getListeditor(n);
                    le.addEntry(item);
                }
            });
            var leOpts = $.extend(el8.appshared.listeditorOpts.practiceUsersAndStaffGroups(), {
                list: function() { return $('#all-' + n + '-list', contentElt); },
                mindreaderOpts: mrOpts
            });

            fields.push({
                name: n,
                selector: ':input[name="' + n + '"]',
                infoText: 'Add provider, staff, or group in practice...',
                listeditorOpts: leOpts
            });
        });

        that._bulkForm = new el8.uiwidget.Form({
             container: contentElt,
             fields: fields,
             buttonElt: $('.bulk-edit-form-buttons', that._container),
             noFirstFocus: true
         });
    },
    that._createBulkFormSaveButton = function () {
        that._bulkForm.addButton('save', 'Update Provider Routes', function(){
            // for each list editor in el8.data.letterCategories, get
            // input name and converts -'s to _'s
            var entriesByKey = _(el8.data.letterCategories.all()).map(function (lrc) {
                var listEditorName = lrc.getKey().replace(/_/g, '-');
                var entries = that._bulkForm.getListeditor(listEditorName+'-recip').getAllEntries();
                return {key: lrc.getKey(), entryStrings: entries};
            });

            _(entriesByKey).each(function(ebk){
                var user_ids = [];
                var staffgroup_ids = [];

                // convert entry strings to ids
                _(ebk.entryStrings).each(function(es){
                    var itemId = parseInt(es.id, 10);
                    if (el8.model.idToModelClass(itemId) === 'StaffGroup' &&
                            el8.data.staffGroups.getById(itemId)) {
                        staffgroup_ids.push(itemId);
                    } else if (el8.data.practiceUsers.getById(itemId)) {
                        user_ids.push(itemId);
                    } else {
                        el8.uiwidget.alert("'" + es.text + "' could not be added to the message route." +
                           " Please choose a valid member of the practice.");
                        return;
                    }
                });

                // indicate which rules to update for all with setForBulkUpdate flag
                if (user_ids.length > 0 || staffgroup_ids.length > 0) {
                    _(el8.data.letterRoutes.all()).each(function (physRouteObj) {
                        _(physRouteObj.getRules()).each(function (rule) {
                            if (rule.getCategory() === ebk.key) {
                                rule.setUserIds(user_ids);
                                rule.setStaffgroupIds(staffgroup_ids);
                                rule.setForBulkUpdate(true);
                            }
                        });
                    });
                }
            });

            // first param is physicianUserId or null for bulk update
            el8.data.letterRoutes.saveAll(null, function () {
                el8.appservice.notifier.notify('Message routing updated for all providers.');
                that.init(that._container);
            });
        }, true);
    },
    that._createBulkFormCancelButton = function () {
        that._bulkForm.addCancelButton(function(){
            that._bulkForm.reset();
            $('.bulk-edit-form-div', that._container).hide();
        }, false);
    },
    that._getMindreaderData = function() {
        var users = el8.data.practiceUsers.all();
        var groups = el8.data.staffGroups.all();
        return users.concat(groups);
    };
    that._updateBulkFormLEs = function () {
        var mrData = that._getMindreaderData();

        that._getletterCategoriesJSNames().forEach(function (name) {
            var le = that._bulkForm._listeditors[name + '-recip'];
            le.mindreader.updateSearchData(mrData);
        });
    },
    that._createProviderForm = function (physRouteObj) {
        var form;
        var fields = [];
        var contentElt = $('#edit-form-provider-'+physRouteObj.getPhysicianUserId());

        // Differnces with bulk form:
        // - has getItemTextFn
        // - no #all- prepend to list
        _(that._getletterCategoriesJSNames()).each(function (name) {
            var n = name + '-recip';

            var mrOpts = $.extend(el8.appshared.mindreaderOpts.practiceUsersAndStaffGroups(), {
                formatSelected: function(item) { return null; },
                selectFn: function(event, item) {
                    var le = form.getListeditor(n);
                    le.addEntry(item);
                }
            });
            var leOpts = $.extend(el8.appshared.listeditorOpts.practiceUsersAndStaffGroups(), {
                list: function() { return $('#' + n + '-list', contentElt); },
                mindreaderOpts: mrOpts
            });

            fields.push({
                name: n,
                selector: ':input[name="' + n + '"]',
                infoText: 'Add provider, staff, or group in practice...',
                listeditorOpts: leOpts
            });
        });

        form = new el8.uiwidget.Form({
            container: contentElt,
            fields: fields,
            buttonElt: $('#edit-form-provider-buttons-'+physRouteObj.getPhysicianUserId())
        });
        return form;
    },
    that._createProviderFormSaveButton = function (p_form, physRouteObj) {
        p_form.addButton('save', "Update Provider's Routes", function(){

            // todo dry
            var entriesByKey = _(el8.data.letterCategories.all()).map(function (lrc) {
                var listEditorName = lrc.getKey().replace(/_/g, '-');
                var entries = p_form.getListeditor(listEditorName+'-recip').getAllEntries();
                return {key: lrc.getKey(), entryStrings: entries};
            });

            _(entriesByKey).each(function(ebk){
                var user_ids = [];
                var staffgroup_ids = [];

                // convert entry strings to ids
                _(ebk.entryStrings).each(function(es){
                    var itemId = parseInt(es.id, 10);
                    if (el8.model.idToModelClass(itemId) === 'StaffGroup' &&
                            el8.data.staffGroups.getById(itemId)) {
                        staffgroup_ids.push(itemId);
                    } else if (el8.data.practiceUsers.getById(itemId)) {
                        user_ids.push(itemId);
                    } else {
                        el8.uiwidget.alert("'" + es.text + "' could not be added to the message route." +
                           " Please choose a valid member of the practice.");
                        return;
                    }
                });

                _(physRouteObj.getRules()).each(function (rule) {
                    if (rule.getCategory() === ebk.key) {
                        rule.setUserIds(user_ids);
                        rule.setStaffgroupIds(staffgroup_ids);
                    }
                });
            });

            var physicianUserId = physRouteObj.getPhysicianUserId();
            var physicianUser = el8.data.practiceUsers.getById(physicianUserId);

            el8.data.letterRoutes.saveAll(physicianUserId, function () {
                el8.appservice.notifier.notify(physicianUser.getFullName() + "'s message routing updated");
                that.init(that._container);
            });
        }, true);
    },
    that._loadAndUpdateFormLEs = function (p_form, physRouteObj) {
        var mrData = that._getMindreaderData();

        // Add current routed to users into the LEs and update the search data
        _(physRouteObj.getRules()).each(function(rule){
            var listEditorName = rule.getCategory().replace(/_/g, '-');
            var le = p_form.getListeditor(listEditorName+'-recip');

            // not just users, need staffgroups too
            var users = _(rule.getUserIds()).map(function (id) {
                return el8.data.practiceUsers.getById(id);
            });
            var sgs = _(rule.getStaffgroupIds()).map(function (id) {
                return el8.data.staffGroups.getById(id);
            });
            le.addEntries(_.compact(users.concat(sgs)));

            le.mindreader.updateSearchData(mrData);
        });
    },
    that._createProviderFormCancelButton = function (p_form, physRouteObj) {
        p_form.addCancelButton(function(){
            p_form.reset();
            that._loadAndUpdateFormLEs(p_form, physRouteObj);
            $('#edit-form-provider-'+physRouteObj.getPhysicianUserId()).hide();
            $('#div-provider-'+physRouteObj.getPhysicianUserId()).show();
        }, false);
    },
    that.init = function(container) {
        that._container = container;

        el8.data.letterCategories.softLoad();
        el8.data.letterRoutes.load(null, false); // synchronous
        el8.data.staffGroups.softLoad();

        // render template and show
        var content = $(el8.template.app.settings.letterRouting.content({
            routesByProvider: that._getRoutesForDisplay()
        }));

        that._container.html(content).show();

        that._createBulkForm();
        that._createBulkFormSaveButton();
        that._createBulkFormCancelButton();
        that._bulkForm.render(); // calls form._init() -> inits form fields -> inits field LE's
        that._updateBulkFormLEs();

        that._bindTriggers();
    };

    return that;
})();
